import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { DownloadIcon, ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[#110038] py-24 md:py-32" data-id="element-228" data-mp="etfx2te3dvbo">
      <div className="mx-auto max-w-4xl px-6" data-id="element-229" data-mp="ercwjffbcjsp">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 24
      }} transition={{
        duration: 0.65,
        ease: 'easeOut'
      }} className="rounded-3xl border border-[#E5A83B]/45 bg-[#0D002B] px-7 py-10 text-center md:px-14 md:py-14" data-id="element-230" data-mp="jt276tymivg9">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-[#E5A83B]/15" data-id="element-231" data-mp="17g0mvpex5zd4">
            <ShieldCheckIcon className="h-9 w-9 text-[#E5A83B]" strokeWidth={1.6} aria-hidden="true" data-id="element-232" data-mp="25pki5klzj99s" />
          </div>
          <p className="mt-6 text-sm font-bold uppercase tracking-[0.18em] text-[#E5A83B]" data-id="element-233" data-mp="1vu9d5u0dpgf8">
            Compra protegida
          </p>
          <h2 className="mt-3 font-serif text-3xl font-bold text-white md:text-4xl" data-id="element-234" data-mp="1ruicmyl1vlxi">
            Tenés 7 días de garantía total
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-[#C4B5FD]" data-id="element-235" data-mp="2jkd4p30alppv">
            Accedés al material de inmediato. Si durante los próximos 7 días
            sentís que el protocolo no te aporta valor, pedís la devolución
            total. Sin preguntas ni vueltas.
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-4 text-sm font-semibold text-[#C4B5FD] sm:flex-row sm:gap-8" data-id="element-236" data-mp="379y04ldmufg1">
            <span className="inline-flex items-center gap-2" data-id="element-237" data-mp="32g3al1bcj691">
              <DownloadIcon className="h-4 w-4 text-[#E5A83B]" aria-hidden="true" data-id="element-238" data-mp="10lp30jaivnc1" />
              Entrega digital inmediata
            </span>
            <span className="inline-flex items-center gap-2" data-id="element-239" data-mp="qvm6480a5p8f">
              <ShieldCheckIcon className="h-4 w-4 text-[#E5A83B]" aria-hidden="true" data-id="element-240" data-mp="vtxjuttp4jvx" />
              Riesgo cero por 7 días
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}